<ng-template #content let-modal>
    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="editClienteLabel">Agregar Dirección</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addDireccionForm">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="InputDireccion">Dirección</label>
                        <input type="text" class="form-control" id="edit_InputDireccion" name="edit_InputDireccion"
                            [formControl]="addDireccionForm.get('direccion')" placeholder="Calle y número (si aplica)"
                            autocomplete="off" (change)="this.chargeMap(this.addDireccionForm.value)">
                    </div>
                </div>
                <div class="col-md-6">
                    <app-typeahead idForm="InputComuna" label="Comuna" [data]="comunas" optField="comuna_nombre"
                        [autocomplete]="false" placeholder="Selecciona comuna"
                        [control]="addDireccionForm.get('comuna_nombre')"
                        (onSelectItem)="onSelectItemComuna($event)"></app-typeahead>
                    <input type="hidden" id="InputIdCliente" name="InputIdCliente"
                        [formControl]="addDireccionForm.get('comuna_id')" autocomplete="off">
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="InputDetalle">Detalle</label>
                        <textarea class="form-control" rows="3" cols="40" id="edit_InputDetalle"
                            [formControl]="addDireccionForm.get('detalle')" name="edit_InputDetalle"
                            placeholder="N° depto / casa / oficina / otro dato (si aplica)"
                            autocomplete="off"></textarea>
                    </div>
                </div>
            </div>
            <div class='col-12 border-bottom p-1 holds-the-iframe' *ngIf="mapa">
                <div class="mapouter">
                    <div class="gmap_canvas">
                        <iframe width="100%" height="200" id="gmap_canvas"
                            [src]="mapa"
                            frameborder="0" scrolling="no" marginheight="0"
                            marginwidth="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-success" (click)="modal.close(addDireccionForm.value)"
                [disabled]="!addDireccionForm.valid">
                <i class="fas fa-map-marked-alt"></i> Agregar
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('Cancel')"><i
                    class="fas fa-times"></i>
                Cancelar</button>
        </div>
    </form>
</ng-template>

<a class="btn btn-success btn-block" [ngClass]="size == '' ? '' : 'btn-'+size" (click)="open(content)">
    <app-popover [classIcon]="'fas fa-plus-circle'" *ngIf="buttonOnlyIcon"
        [message]="'Agregar dirección'"></app-popover>
    <div *ngIf="!buttonOnlyIcon"><i class="fas fa-plus-circle"></i> Agregar dirección</div>
</a>